export function formatNumberWithCommas(number: number, maximumFractionDigits = 0) {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits,
  })

  const formattedNumber = numberFormatter.format(number)
  return formattedNumber
}
